import React from 'react'
import Link from 'gatsby-link'

import Fill from '../../images/Fill.svg'

const DigitalmarketingSidebar = () => (
  <section>
    <article>
      <div style={{display:'block'}}>
        <h1 className='smallerHone'>Digital Marketing</h1>
        <img src={Fill} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/><br/>
        <Link to="/services/digital-marketing/social-media-marketing/" className='slide'>Social Media Marketing</Link><br/>
        <Link to="/services/digital-marketing/google-marketing/" className='slide'>Google Marketing</Link><br/>
        <Link to="/services/digital-marketing/email-marketing/" className='slide'>Email Marketing</Link><br/>
        <Link to="/services/digital-marketing/seo/" className='slide'>SEO</Link><br/>
        <Link to="/services/digital-marketing/online-reputation-management/" className='slide'>Online Reputation Management</Link><br/>
        <Link to="/services/digital-marketing/content-marketing/" className='slide'>Content Marketing</Link><br/>
        <Link to="/services/digital-marketing/influencers-and-affiliated-marketing/" className='slide'>Influencers and Affiliated Marketing</Link><br/>
        <Link to="/services/digital-marketing/video-marketing/" className='slide'>Video Marketing</Link>
      </div>
    </article>
  </section>
)

export default DigitalmarketingSidebar



// WEBPACK FOOTER //
// ./src/components/DigitalmarketingSidebar/index.js